const categoryTypes = [
  { label: 'Generales', value: 'general' },
  { label: 'Vida', value: 'life' },
  { label: 'Ambos', value: 'both' }
];

export default categoryTypes;
